import home from '@/language/ja-JP/home'
import industry from '@/language/ja-JP/industry'
import about from '@/language/ja-JP/about'
import jobs from '@/language/ja-JP/jobs'
import contact from '@/language/ja-JP/contact'
import cases from '@/language/ja-JP/cases'
import awards from '@/language/ja-JP/awards'
// サービス
import enterprise from '@/language/ja-JP/service/enterprise'
import businessProcess from '@/language/ja-JP/service/businessProcess'
import digital from '@/language/ja-JP/service/digital'
import enterpriseApplication from '@/language/ja-JP/service/enterpriseApplication'
import crm from '@/language/ja-JP/service/crm'

import blockchains from '@/language/ja-JP/service/blockchains'
import businessApplication from '@/language/ja-JP/service/businessApplication'
import dataAnalytics from '@/language/ja-JP/service/dataAnalytics'
import artificialIntelligence from '@/language/ja-JP/service/artificialIntelligence'
import aiVideoProduction from '@/language/ja-JP/service/aiVideoProduction'

import softwareDevelopment from '@/language/ja-JP/service/softwareDevelopment'
import enterpriseMobility from '@/language/ja-JP/service/enterpriseMobility'
import cloud from '@/language/ja-JP/service/cloud'
import intelligentManufacturing from '@/language/ja-JP/service/intelligentManufacturing'
import networkSecurity from '@/language/ja-JP/service/networkSecurity'
import globalization from '@/language/ja-JP/service/globalization'
import bigData from '@/language/ja-JP/service/bigData'
import internetThings from '@/language/ja-JP/service/internetThings'

import applicationOutsourcing from '@/language/ja-JP/service/applicationOutsourcing'
import businessProcessOutsourcing from '@/language/ja-JP/service/businessProcessOutsourcing'
import customerService from '@/language/ja-JP/service/customerService'
import humanResource from '@/language/ja-JP/service/humanResource'
import gamingField from '@/language/ja-JP/service/gamingField'

export default {
  home,
  industry,
  about,
  jobs,
  contact,
  cases,
  awards,
  // サービス
  enterprise,
  businessProcess,
  digital,
  enterpriseApplication,
  crm,
  blockchains,
  businessApplication,
  dataAnalytics,
  artificialIntelligence,
  aiVideoProduction,
  softwareDevelopment,
  enterpriseMobility,
  cloud,
  intelligentManufacturing,
  networkSecurity,
  globalization,
  bigData,
  internetThings,
  applicationOutsourcing,
  businessProcessOutsourcing,
  customerService,
  humanResource,
  gamingField
}
